import React, { useMemo } from "react"
import { useParams } from "react-router-dom";
import DashboardWidget from "../../quicksight/presentation/widgets/dashboard.widget";
import useGetQuickSightDashboard from "hooks/quicksight/useGetQuicksightDashboard";
import "../../../scss/common.scss";
import { useStateContext } from "state";


const AccountDashboardPage: React.FC = () => {
    const { id } = useParams() as { id: string };
    const state = useStateContext();

    const role = useMemo(() => {
        return state.user?.roles.find((value) => value.accountNumber === id)
    }, [state.user])

    const result = useGetQuickSightDashboard(id);

    if (role?.isAdhoc) {
        return <div className="center">coming soon...</div>
    }

    return (
        <DashboardWidget data={result.data} isLoading={result.isLoading} isError={result.isError} error={result.error} />
    )

}

export default AccountDashboardPage;
